import { ROUTES } from '@/constants/routes/default';
import { getFullYear } from '@/helpers/date';
import Image from 'next/image';
import Link from 'next/link';

const FooterMC = ({ isAuthorized }: { isAuthorized: boolean }) => {
  return (
    <footer className="flex flex-col md:px-10 max-md:px-4 md:py-8 max-md:py-6 bg-mc-shark border-t border-mc-tuna">
      <div className="max-w-300 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4 max-md:flex-col max-md:items-start max-md:gap-5">
        <div>
          <Link href={ROUTES.home} aria-label="McCarthy Search home">
            <Image
              width="174"
              height="20"
              src="https://assets.mccarthysearch.com/mccarthy/mc-logo.png"
              alt="McCarthy Search"
              unoptimized
              priority
            />
          </Link>
          <p className="mt-3 text-mc-santas-gray text-[13px] md:max-w-65">
            Job matching for people who&apos;d rather set their preferences once than scroll a board
            every night.
          </p>
        </div>
        <nav
          aria-label="Footer"
          className="w-fit flex flex-wrap gap-y-2 gap-x-20 text-mc-santas-gray font-medium text-sm"
        >
          <ul className="flex flex-col gap-4">
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.jobs}>
                Jobs
              </Link>
            </li>
            <li>
              {isAuthorized ? (
                <Link className="block w-fit hover:underline" href={ROUTES.profile}>
                  Match profile
                </Link>
              ) : (
                <Link className="block w-fit hover:underline" href={ROUTES.signup}>
                  Get matched
                </Link>
              )}
            </li>
            <li>
              <Link className="text-sm block w-fit hover:underline" href={ROUTES.partners}>
                For employers
              </Link>
            </li>
          </ul>
          <ul className="flex flex-col gap-4">
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.home}>
                How it works
              </Link>
            </li>
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.privacyPolicy}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link className="block w-fit hover:underline" href={ROUTES.termsOfUse}>
                Terms of Use
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="flex justify-between items-center m-auto max-w-300 w-full border-t border-mc-tuna pt-6 mt-6">
        <p className="text-mc-santas-gray text-xs">
          © McCarthy Search, {getFullYear()} 10736 Jefferson Blvd Suite 390, Culver City, CA 90230
        </p>
      </div>
    </footer>
  );
};

export default FooterMC;
